import React from "react";
import Header from "../Components/Header";
import ProductList from "../Components/ProductList";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";
import banner2 from "../assets/images/banner2.png";

export default function Sale() {
  return (
    <>
      <Header mode="dark" />
      <div className="container-fluid">
        <div id="carouselExample" class="carousel slide">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img src={banner2} alt="Banner" />
            </div>
            <div class="carousel-item">
              <img src={banner2} alt="Banner" />
            </div>
          </div>
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExample"
            data-bs-slide="prev"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#carouselExample"
            data-bs-slide="next"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      <div className="pt-3">
        <ProductList />
      </div>

      <Feature />
      <Footer />
    </>
  );
}
